import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import {
  provideTranslocoScope,
  TranslocoModule,
} from '@jsverse/transloco';

@Component({
  selector: 'mzic-investor-promo-banner',
  imports: [CommonModule, TranslocoModule],
  templateUrl: './investor-promo-banner.component.html',
  styleUrl: './investor-promo-banner.component.scss',
  providers: [
    provideTranslocoScope({
      scope: 'investor-landing',
      alias: 'lang',
    }),
  ],
})
export class InvestorPromoBannerComponent {
  @Output() closeBanner = new EventEmitter<void>();
  @Output() ctaClick = new EventEmitter<void>();
  readonly closeIconUrl = 'assets/icons/mzic-close.svg';

  emitCloseBanner() {
    this.closeBanner.emit();
  }

  emitCtaClick() {
    this.ctaClick.emit();
  }
}
